import { useQuery } from '@tanstack/react-query'

import { TANSTACK_QUERY_KEY } from '@/constants/tanstack-query'

import { TradeSetting } from '../models'

export const useQueryTradeSetting = () => {
  return useQuery({
    queryKey: [TANSTACK_QUERY_KEY.SETTINGS.TRADE],
    queryFn: async () => {
      const response = await TradeSetting.getTradeSetting()
      return response.data
    },
  })
}
